import { AuctionStatusHistoryDTO } from "../DTO/auctionStatusHistoryDTO";

export class AuctionStatusHistory{
    public id!:number;
    public auctionId!:number;
    public scheduleSeqNo?:number;
    public status!:string;
    public enteredAt!:Date;
    public userName!:string;
    public reason!:string;

    public static mapToDTO(param:AuctionStatusHistory) : AuctionStatusHistoryDTO{
        
        let dto = new AuctionStatusHistoryDTO();
        try
        {
            dto.id = param.id;
            dto.auctionId = param.auctionId;
            dto.scheduleSeqNo = param.scheduleSeqNo;
            dto.status = param.status;
            dto.enteredAt = param.enteredAt.toISOString();
            dto.userName = param.userName;
            dto.reason = param.reason;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:AuctionStatusHistoryDTO) : AuctionStatusHistory
    {
        
        let obj = new AuctionStatusHistory();
        try
        {
            obj.id = param.id;
            obj.auctionId = param.auctionId;
            obj.scheduleSeqNo = param.scheduleSeqNo;
            obj.status = param.status;
            obj.enteredAt = new Date(param.enteredAt);
            obj.userName = param.userName;
            obj.reason = param.reason;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}